<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input class="filter-item" v-model="listQuery.hotel_code" placeholder="酒店编码" style="width: 220px" clearable
        size="small" />
      <el-input class="filter-item" v-model="listQuery.room_code" placeholder="房型编码" style="width: 220px" clearable
        size="small" />
      <el-input class="filter-item" v-model="listQuery.policy_id" placeholder="政策ID" style="width: 220px" clearable
        size="small" />
      <el-date-picker class="filter-item" v-model="dateRange" type="daterange" range-separator="至"
        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="display: inline-flex"
        size="small" @change="handleDateChange" />

      <el-button class="filter-item" type="primary" @click="handleFilter" size="small">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row
      size="small">
      <el-table-column label="ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="酒店编码" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_code }}
        </template>
      </el-table-column>

      <el-table-column label="房型编码" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_code }}
        </template>
      </el-table-column>

      <el-table-column label="政策ID" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.policy_id }}
        </template>
      </el-table-column>

      <el-table-column label="日期" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.date }}
        </template>
      </el-table-column>

      <el-table-column label="日价格" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.daily_price }}
        </template>
      </el-table-column>

      <el-table-column label="库存" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.quota }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="更新时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at }}
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5, 10, 20, 30, 50]" :page-size="listQuery.limit"
        :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      dateRange: null,
      listQuery: {
        page: 1,
        limit: 10,
        hotel_code: '',
        room_code: '',
        policy_id: '',
        start_date: '',
        end_date: '',
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/suiChuan/hotel/roomStatusList',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.items
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    handleDateChange(val) {
      if (val) {
        this.listQuery.start_date = val[0]
        this.listQuery.end_date = val[1]
      } else {
        this.listQuery.start_date = ''
        this.listQuery.end_date = ''
      }
      this.listQuery.page = 1
      this.getList()
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped></style>
